<template>
  <v-container fluid fill-height align-start ma-0 pa-0>
    <v-card v-if="overlay" width="100%" @click="overlay = false" style="cursor: default;">
      <v-overlay :v-model="overlay" :opacity="0.8" style="z-index: 3000">
        <v-card width="100%" class="d-flex justify-center align-center">
          <v-img :src="imgPreview" height="80vh" max-height="80vh" width="70vw" max-width="70vw" contain />
        </v-card>
      </v-overlay>
    </v-card>

    <v-row v-if="createDt" no-gutters class="mt-5">
      <v-col cols="12" class="d-flex">
        <span>작성일자: {{ createDt ? createDt : '-' }}</span>
        <span style="margin-left: 100px;">수정일자: {{ updateDt ? updateDt : '-' }}</span>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <!-- <v-form class="pt-1" style="width:100%; height:55vh;"> -->
      <v-card width="100%" height="100%" class="overflow-hidden overflow-y-auto">
        <!-- <v-img :src="imgSrc" style="width:100%; height:auto; object-fit: contain;" /> -->
        <v-hover v-if="createDt">
          <template v-slot:default="{ hover }">
            <span class="d-flex justify-center align-center" style="width:100%; height: 100%; cursor: pointer;" @click="imgClick(true)">
              <v-img :src="imgSrc" height="100%" max-height="50vh" width="100%" max-width="100%" contain />

              <v-fade-transition>
                <v-overlay v-if="hover" absolute :opacity="0.8">
                  <h4>
                    이미지 크게보기
                  </h4>
                </v-overlay>
              </v-fade-transition>
            </span>
          </template>
        </v-hover>

        <span v-else-if="uploadFile.fileNm" class="d-flex align-center justify-center" style="width:100%; height: 100%;">
          <v-hover>
            <template v-slot:default="{ hover }">
              <span class="d-flex justify-center align-center" style="width:100%; height: 100%; cursor: pointer;" @click="imgClick(false)">
                <v-img
                  :src="imgPreview"
                  height="100%"
                  max-height="50vh"
                  width="100%"
                  max-width="100%"
                  style="cursor:pointer"
                  contain
                  @click="imgClick"
                />
                <v-fade-transition>
                  <v-overlay absolute :opacity="0.5">
                    <h4>{{ `${uploadFile.fileNm}.${uploadFile.extension}` }} 업로드 준비 완료</h4>
                  </v-overlay>
                </v-fade-transition>
              </span>
            </template>
          </v-hover>
        </span>

        <v-img v-else :src="require(`@/assets/images/etc/noImage.png`)" height="100%" max-height="55vh" width="100%" max-width="100%" contain />
      </v-card>
      <!-- </v-form> -->
    </v-row>
    <DxFileUploader
      :ref="dxFileUploader"
      :accept="allowedFileExtensions.join(', ')"
      :multiple="true"
      upload-mode="useButtons"
      selectButtonText="Select File"
      :allowed-file-extensions="allowedFileExtensions"
      :show-file-list="false"
      labelText
      width="100%"
      dialog-trigger="[role=btnImageLoad]"
      @uploaded="onUploaded"
      @upload-error="onUploadError"
      @value-changed="onValueChanged"
      :visible="false"
    />
  </v-container>
</template>

<script>
// 공통 컴포넌트
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import { DxFileUploader } from 'devextreme-vue/file-uploader'
import { getCurrentDate } from '@/utils/common.js'
import _ from 'lodash'
// 사용자 컴포넌트
// API
import { saveSHManageData } from '@/api/leaderShip/shManagePolicy'
import { downloadFile, multiFileUpload, deleteFilesWithTarget } from '@/api/baseManage/fileUpload'
import { getSHManageData } from '@/api/leaderShip/shManagePolicy'

export default {
  mixins: [baseview],
  components: {
    DxFileUploader
  },
  props: {
    datasource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      buttonUseList: [
        'btnSave' // 저장
      ],
      dxFileUploader: 'uploaderContainer',
      maxFileSize: 1073741824,
      allowedFileExtensions: ['.jpg', '.jpeg', '.png'],
      uploadFile: {},
      imgSrc: '',
      imgPreview: '',
      params: {
        // clntId: this.getClntId(),
        // compId: this.getCompId(),
        // dataType: '00001'
      },
      createDt: '',
      updateDt: '',
      overlay: false
    }
  },
  watch: {
    datasource: {
      deep: true,
      handler() {
        // 데이터 바인딩
        this.dataInit()
      }
    }
  },
  computed: {
    fileUploader: function() {
      return this.$refs[this.dxFileUploader].instance
    }
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.dataInit()
  },
  activated() {},
  methods: {
    dataInit() {
      this.uploadFile = {}
      this.params = _.cloneDeep(this.datasource)
      if (Object.keys(this.params).length == 0) {
        ;(this.params.clntId = this.getClntId()), (this.params.dataType = '00001'), (this.params.__created__ = true)
      } else {
        this.imgLoad()
      }
      this.createDt = this.params.createdAt ? this.params.createdAt.substr(0, 19).replaceAll('-', '.') : ''
      this.updateDt = this.params.updatedAt ? this.params.updatedAt.substr(0, 19).replaceAll('-', '.') : ''
    },
    btnImageDownload() {
      // 이미지 다운로드
      // api 에 responseType: "blob" 필수, 백단에 byteArray(Blob)형태로 보내고 있기 때문
      let params = {
        targetType: '00005',
        targetId: `${this.getClntId()}_${this.params.dataType}`
      }
      if (this.createDt) {
        this.openLoading()
        downloadFile(params)
          .then(res => {
            let link = document.createElement('a')
            // 객체를 만들어서 생성
            let objectUrl = window.URL.createObjectURL(res)
            link.href = objectUrl
            // link.download = `${this.selectedFileData.fileNm}.${this.selectedFileData.extension}`
            link.download = `안전보건경영방침(${this.params.writeDt}).png`
            link.click()
          })
          .finally(() => this.endLoading())
      } else {
        this.vSnackbar(this.$t('다운로드할 이미지가 없습니다.'), 'warn')
      }
    },
    btnImageLoad() {
      console.log('## 이미지 불러오기 ')
      this.fileUploader.repaint()
      // 이미지 불러오기
    },
    btnSave() {
      // 저장
      if (Object.keys(this.uploadFile).length > 0) {
        this.openLoading()
        saveSHManageData(this.uploadFile, false)
          .then(res => {
            this.fileUpload()
            // this.uploadFile = {}
          })
          .catch(e => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      } else {
        this.vSnackbar(this.$t('저장할 파일이 없습니다.'), 'warn')
      }
    },
    fileUpload() {
      // 기존 파일 삭제 후 업로드
      console.log('# this.getClntId()', this.getClntId())
      let deleteParam = {
        targetId: `${this.getClntId()}_${this.uploadFile.dataType}`,
        targetType: '00005',
        clntId: this.getClntId()
      }
      deleteFilesWithTarget(deleteParam)
        .then(res => {
          if (res.success) {
            this.params.__created__ = false
            let formData = new FormData()
            formData.append('fileList[0].fileData', this.uploadFile.file ? this.uploadFile.file : new Blob([], { type: 'application/octet-stream' }))
            formData.append('fileList[0].fileVO.targetId', `${this.getClntId()}_${this.uploadFile.dataType}`)
            formData.append('fileList[0].fileVO.targetType', this.uploadFile.targetType)
            formData.append('fileList[0].fileVO.useYn', this.uploadFile.useYn)
            formData.append('fileList[0].fileVO.clntId', this.getClntId())
            multiFileUpload(formData, true)
              .then(res => {
                if (res.success) {
                  //
                  this.imgLoad()
                  // this.updateDt = getCurrentDate().replaceAll('-', '.')
                }
              })
              .finally(() => {
                this.endLoading()
              })
          }
        })
        .catch(e => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    imgLoad() {
      let params = {
        targetType: '00005',
        targetId: `${this.getClntId()}_${this.params.dataType}`
      }
      downloadFile(params)
        .then(res => {
          // 객체를 만들어서 생성
          let objectUrl = window.URL.createObjectURL(res)
          this.imgSrc = objectUrl
        })
        .finally(() => {
          getSHManageData({ clntId: this.getClntId(), dataType: '00001' }, false).then(res => {
            this.params = res.clntId ? res : {}
            this.createDt = this.params.createdAt ? this.params.createdAt.substr(0, 19).replaceAll('-', '.') : ''
            this.updateDt = this.params.updatedAt ? this.params.updatedAt.substr(0, 19).replaceAll('-', '.') : ''
          })
          this.endLoading()
        })
    },
    previewImage(file) {
      const reader = new FileReader()
      reader.onload = e => {
        this.imgPreview = window.URL.createObjectURL(this.base64toBlob(e.target.result))
        console.log('########################## ', this.imgPreview)
      }
      this.imgPreview = reader.readAsDataURL(file)
    },
    base64toBlob(base64Data) {
      let byteString = atob(base64Data.split(',')[1])
      let mimeType = base64Data
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      let arrayBuffer = new ArrayBuffer(byteString.length)
      let uint8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i)
      }
      return new Blob([arrayBuffer], { type: mimeType })
    },
    onUploaded(e) {
      e.component._files.forEach((element, index) => {
        if (element._isLoaded) {
          this.fileUploader.removeFile(index)
        }
      })
      this.vSnackbar(this.$t('파일이 업로드 되었습니다.'), 'warn')
    },
    onUploadError(e) {
      e.component._files.forEach((element, index) => {
        if (element._isError) {
          this.fileUploader.removeFile(index)
          this.vSnackbar(this.$t('파일을 업로드 할 수 없습니다'), 'warn')
        }
      })
    },
    onValueChanged(e) {
      // reset 이벤트는 재귀적으로 이 이벤트를 부르기 때문에 0일때 return 시킴
      if (e.value == null || e.value.length == 0) return
      if (e.value[0] && e.value[0].type.startsWith('image/')) {
        // 파일이 이미지인 경우에만 미리보기 표시
        this.previewImage(e.value[0])
      } else {
        this.imgPreview = null // 이미지가 아닌 경우에는 미리보기 초기화
      }
      this.openLoading()
      if (e.value.length > 1) {
        this.vSnackbar(this.$t('파일은 한 개만 등록 가능합니다.'), 'warn')
        this.fileUploader.reset()
        this.endLoading()
        return
      }
      if (e.value[0].size >= this.maxFileSize) {
        this.vSnackbar(this.$t('파일이 용량이 1GB를 초과했습니다.'), 'warn')
        this.fileUploader.reset()
        this.endLoading()
        return
      }
      let subFileName = this.getExtension(e.value[0].name)
      if (subFileName[0].length > 200) {
        this.vSnackbar(this.$t('파일의 이름이 200자 이상입니다.'), 'warn')
        this.fileUploader.reset()
        this.endLoading()
        return
      }
      if (!this.allowedFileExtensions.includes('.' + subFileName[1])) {
        this.vSnackbar(this.$t('파일의 확장자가 허용되지 않습니다.'), 'warn')
        this.fileUploader.reset()
        this.endLoading()
        return
      }
      console.log('## e.value', e.value)
      let writeDt = getCurrentDate()
        .split('-')
        .join('')
      this.uploadFile = {
        id: 'uploadFile',
        clntId: this.getClntId(),
        compId: this.params.compId,
        dataType: this.params.dataType,
        writeDt: writeDt,
        docNo: '',
        file: new File([e.value[0]], `${subFileName[0]}.${subFileName[1]}`),
        fileNm: subFileName[0],
        extension: subFileName[1],
        fileSize: this.getfileSize(e.value[0].size),
        useYn: 'Y',
        targetType: '00005',
        __created__: this.params.__created__
      }
      this.fileUploader.reset()
      this.endLoading()
      this.createDt = ''
    },
    getExtension(fileName) {
      let fileLen = fileName.length

      let lastDot = fileName.lastIndexOf('.')
      let extension = fileName.substring(lastDot + 1, fileLen).toLowerCase()
      let baseName = fileName.substring(0, lastDot)
      return [baseName, extension]
    },
    getfileSize(size) {
      return (size / 1048576).toFixed(3) + 'MB'
    },
    imgClick(isLegacy) {
      this.overlay = true
      if (isLegacy) this.imgPreview = _.clone(this.imgSrc)
    }
  }
}
</script>

<style lang="scss"></style>
